export default function ({ $config }, inject) {
  const VentrataController = require('../api/VentrataController').default
  const controller = new VentrataController($config)
  inject('ventrataController', controller)
}